export default __webpack_public_path__ + "assets/small-pin.3a5b.svg";